/**
 * Application Configuration API Service
 */
import { fetcher } from '../../../services/api';
import type { ProfileResponse } from '../types/appConfig';

export const PROFILE_QUERY_KEY = ['profile'];

/**
 * Gets user profile including roles, features, and onboarding status
 * Backend controls which features are enabled per user/environment
 * 
 * @returns Promise resolving to profile response
 */
export const getProfile = async (): Promise<ProfileResponse> => {
  return fetcher<ProfileResponse>('/api/v1/profile/me');
};
